import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Projects.css';

interface Project {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  fullDescription: string;
  features: string[];
  technologies: string[];
  image: string;
  category: 'mobile' | 'web' | 'security' | 'ai' | 'desktop';
  status: 'completed' | 'in-progress';
  links?: {
    playStore?: string;
    appStore?: string;
    demo?: string;
    website?: string;
    fdroid?: string;
    roblox?: string;
    testflight?: string;
    discord?: string;
    telegram?: string;
  };
}

const Projects: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<string>('all');

  const projects: Project[] = [
    {
      id: 1,
      title: "Aplicación Android de Seguridad",
      subtitle: "Borrado Remoto",
      description: "🚀 Remote Wipe App – Gestión y Seguridad para Dispositivos Android. Protege y administra tus dispositivos Android en tiempo real. Ideal para usuarios y empresas que requieren control total. 💼🔒",
      fullDescription: "Es un FORK de SESSION enfocado en la privacidad y seguridad, resolviendo posibles vectores de ataque en tu código. Todo el ecosistema funciona igual que SESSION, pero con diferencias claves:",
      features: [
        "🔥 Borrado Remoto de Dispositivos: Elimina datos a distancia en caso de pérdida o robo",
        "🔑 Intentos de Desbloqueo Fallidos: Configura el borrado automático tras varios intentos fallidos",
        "📡 Notificaciones en Tiempo Real: Monitoriza y actualiza el estado del dispositivo desde el servidor",
        "🛡️ Gestión de Licencias: Registro y administración segura de licencias",
        "🖥️ Compatibilidad con MDM: Aprovecha el modo \"Owner\" de Android para un control total"
      ],
      technologies: ["Kotlin", "Jetpack Compose", "DevicePolicyManager", "Node.js", "WebSocket", "PostgreSQL", "JWT"],
      image: "/images/projects/proyecto1.png",
      category: "security",
      status: "completed"
    },
    {
      id: 2,
      title: "Escáner Facial & Detector de Atributos",
      subtitle: "ANDROID",
      description: "🚀 EscánerFacial Belleza – ¡Realza tu rostro con IA! 🤳 Descubre tu mejor versión con nuestro escáner avanzado que analiza más de 40 puntos clave de tu rostro.",
      fullDescription: "Obtén consejos personalizados para resaltar tus rasgos más atractivos, mide la simetría facial de manera precisa y diviértete comparándote con tus celebridades favoritas.",
      features: [
        "Análisis de Belleza Facial: Genera gráficos detallados que destacan proporciones de ojos, pómulos y labios",
        "Escaneo Facial Simétrico: Verifica el nivel de simetría en ambos lados del rostro",
        "Comparador de Famosos: Identifica a qué celebridad te pareces más con algoritmos de similitud",
        "Recomendaciones personalizadas para equilibrar tus facciones"
      ],
      technologies: ["Kotlin", "Java", "MediaPipe", "OpenCV", "Machine Learning"],
      image: "/images/projects/proyecto2.png",
      category: "ai",
      status: "completed",
      links: {
        playStore: "https://play.google.com/store/apps/details?id=com.marquez.detection&hl=es"
      }
    },
    {
      id: 3,
      title: "SecureYourChats",
      subtitle: "NewOverlayTechnology",
      description: "Encripta o desencripta texto y archivos con algoritmos potentes (AES, DES, CAMELLIA, ChaCha20-Poly1305, XChaCha20-Poly1305, Aegis256).",
      fullDescription: "Interfaz intuitiva para máxima seguridad y privacidad en tus comunicaciones digitales.",
      features: [
        "📝 Text Encryption/Decryption: Interfaz intuitiva para ingresar texto, elegir algoritmo y ver resultados",
        "🔑 Compartir/Importar Claves vía QR: Comparte tu clave o importa la de otros fácilmente",
        "📁 File Encryption/Decryption: Selecciona archivos y aplica los mismos algoritmos",
        "🗝️ Built-In Key Manager: Añade, borra o genera claves aleatorias",
        "♿ Servicio de Accesibilidad (Opcional): Detecta texto seleccionado o copiado"
      ],
      technologies: ["Android", "AES", "DES", "CAMELLIA", "ChaCha20-Poly1305", "EncryptedSharedPreferences"],
      image: "/images/projects/proyecto3.png",
      category: "security",
      status: "completed",
      links: {
        fdroid: "https://f-droid.org/es/packages/com.encrypt.bwt/"
      }
    },
    {
      id: 4,
      title: "ThreadScoopOnionChat",
      subtitle: "",
      description: "🚀 ThreatScoopOnionChat – ¡Protege tus conversaciones con seguridad avanzada! 🔒 Es un FORK de SESSION enfocado en la privacidad y seguridad.",
      fullDescription: "Resuelve posibles vectores de ataque en tu código. Todo el ecosistema funciona igual que SESSION, pero con diferencias claves.",
      features: [
        "Claves de 256 bits (en lugar de 128 bits en SESSION)",
        "25 Palabras Mnemónicas (vs. 12 en SESSION)",
        "Capa extra de cifrado en todo el ecosistema",
        "Eliminación de GoogleServices en el proyecto",
        "Función ExtraSecurity: el núcleo de ThreatScoopOnionChat"
      ],
      technologies: ["Android", "Signal Protocol", "Encryption", "Privacy", "Session Fork"],
      image: "/images/projects/proyecto4.png",
      category: "security",
      status: "completed",
      links: {
        fdroid: "https://f-droid.org/packages/com.bwt.threadscooponionchatcom/"
      }
    },
    {
      id: 5,
      title: "SecureChatsKeyboard",
      subtitle: "",
      description: "🚀 SecureChats KEYBOARD – ¡Cifrado de extremo a extremo (E2EE) para cualquier app! 🔒 Es un teclado de Android que integra el Protocolo Signal (X3DH y Double Ratchet).",
      fullDescription: "Ahora cifrado post-cuántico Kyber, sin depender de un servidor. Comunícate de forma segura e independiente, incluso si tu mensajería favorita no soporta E2EE.",
      features: [
        "Envía y recibe mensajes cifrados en cualquier app mediante un campo de texto sobre el teclado",
        "Decodifica mensajes usando el portapapeles",
        "Administra contactos directamente en el teclado",
        "Modo Raw o Modo Cuento de Hadas (Fairytale) para disfrazar la data",
        "Basado en el Protocolo Signal (X3DH, Double Ratchet) con AES-256-CBC y SHA-256"
      ],
      technologies: ["Android", "Signal Protocol", "X3DH", "Double Ratchet", "Kyber", "E2EE"],
      image: "/images/projects/proyecto5.png",
      category: "security",
      status: "completed",
      links: {
        playStore: "https://play.google.com/store/apps/details?id=com.bwt.securechats&hl=es"
      }
    },
    {
      id: 6,
      title: "PatronesCostura & Asistente",
      subtitle: "",
      description: "🚀 ¡Bienvenido(a) a la mejor aliada para tu pasión por la costura! 🧵✨ Nuestra aplicación combina patrones de costura personalizados, asistente de costura inteligente y herramientas prácticas.",
      fullDescription: "Para llevar tus creaciones a un nivel profesional, seas principiante o experto(a) en diseño de modas.",
      features: [
        "Patrones Básicos y Avanzados: Accede a una amplia selección de patrones (blusas, faldas, pantalones, mangas, etc.)",
        "Generador de PDFs: Crea, combina e imprime tus patrones en formato PDF desde la app",
        "Gestor de Perfiles de Medidas: Guarda las medidas de varias personas",
        "Vista Previa y Personalización: Observa cada pieza antes de imprimir",
        "Asistente de Costura Integrado 🤖: Responde dudas sobre técnicas, telas, cortes"
      ],
      technologies: ["Flutter", "PDF Generation", "AI Assistant", "Pattern Design"],
      image: "/images/projects/proyecto6.png",
      category: "mobile",
      status: "completed",
      links: {
        playStore: "https://play.google.com/store/apps/details?id=com.marquez.bettypatrones"
      }
    },
    {
      id: 7,
      title: "CogniTest",
      subtitle: "",
      description: "🚀 CogniTest – ¡Ejercita tu mente de forma divertida y accesible! 🧠✨ Pon a prueba tu velocidad de reacción, memoria y reflejos con una serie de desafíos.",
      fullDescription: "Diseñados para mantener tu cerebro ágil. Compara tus resultados con usuarios de todo el mundo y sigue tu progreso en el tiempo.",
      features: [
        "Tiempo de Reacción",
        "Velocidad de Escritura",
        "Chimp Test",
        "Memoria Numérica",
        "Test de Audición",
        "Memoria Verbal",
        "Comparaciones Globales: Descubre en qué porcentaje te ubicas respecto a otros participantes"
      ],
      technologies: ["Flutter", "Kotlin", "Cognitive Testing", "Analytics"],
      image: "/images/projects/proyecto7.png",
      category: "mobile",
      status: "completed",
      links: {
        playStore: "https://play.google.com/store/apps/details?id=com.marquez.cognitivetrain&hl=es"
      }
    },
    {
      id: 8,
      title: "FrozenBalls (REBRANDING)",
      subtitle: "",
      description: "🔥❄️ ¡Bienvenido a Frozen Balls! El juego que fusiona hielo y fuego para ofrecer una experiencia única y desafiante.",
      fullDescription: "Aunque su nombre evoque frescura, prepárate para enfrentar escenarios infernales llenos de acción y adrenalina.",
      features: [
        "Mecánica Clásica y Adictiva: Conecta 3 o más burbujas para despejar el tablero",
        "Ambiente Infernal Único: Un contraste visual impactante del frío al calor del infierno",
        "Multijugador (2 Modos): Disfruta en solitario o reta a un amigo en partidas de 2 jugadores",
        "Diseño Moderno y Fluido: Interfaz intuitiva y jugabilidad pulida",
        "Gráficos HD y personajes renovados, mezclando lo retro con elementos modernos"
      ],
      technologies: ["Java", "Android Game Development", "OpenGL"],
      image: "/images/projects/proyecto8.png",
      category: "mobile",
      status: "completed",
      links: {
        playStore: "https://play.google.com/store/apps/details?id=com.bwtn.frozenbubble&hl=es"
      }
    },
    {
      id: 9,
      title: "SLEEPINESS Detector",
      subtitle: "",
      description: "🚗 SLEEPINESS Detector – ¡Porque tu seguridad es lo primero! 🛡️ Una aplicación que puede salvar vidas, diseñada para mantener seguros a los conductores durante sus viajes.",
      fullDescription: "Detecta señales tempranas de fatiga y previene accidentes antes de que ocurran. Tu copiloto digital que nunca duerme.",
      features: [
        "👁️ Detección Avanzada: Monitoreo en tiempo real del estado de los ojos del conductor",
        "🎯 Precisión y Velocidad: Tecnología Google ML Kit para detección facial precisa",
        "🔔 Sistema de Alerta: Alarma sonora potente y efectiva tipo bocina",
        "🛡️ Privacidad Primero: No almacena imágenes ni datos personales",
        "Procesamiento 100% local en el dispositivo"
      ],
      technologies: ["Flutter", "Google ML Kit", "Computer Vision", "Real-time Processing"],
      image: "/images/projects/proyecto9.png",
      category: "ai",
      status: "completed",
      links: {
        playStore: "https://play.google.com/store/apps/details?id=com.bwt.driverassistant&hl=es"
      }
    },
    {
      id: 10,
      title: "Gestión de Gimnasios",
      subtitle: "ElevenSport",
      description: "🏋️‍♂️ ElevenSport – ¡Sistema integral para la gestión moderna de gimnasios! 💪 Una solución completa que combina gestión de usuarios, inventario, dietas, entrenamientos y ventas.",
      fullDescription: "En una única plataforma. Diseñada para optimizar la administración y mejorar la experiencia tanto de propietarios como de usuarios.",
      features: [
        "👥 Gestión de Usuarios: Control completo de membresías y accesos",
        "🥗 Sistema de Dietas: Creación y asignación de planes nutricionales personalizados",
        "💪 Gestión de Entrenamientos: Biblioteca completa de ejercicios y rutinas",
        "📦 Control de Inventario: Gestión de productos y suplementos",
        "💳 Sistema de Ventas Integrado: Procesamiento de pagos online y en persona"
      ],
      technologies: ["Flutter", "Firebase", "Firebase Authentication", "Cloud Firestore", "Firebase Storage"],
      image: "/images/projects/proyecto10.png",
      category: "mobile",
      status: "completed",
      links: {
        appStore: "https://apps.apple.com/at/app/eleven-private-sport-club/id6744098449"
      }
    },
    {
      id: 11,
      title: "Gestión Lila",
      subtitle: "",
      description: "💼 Gestión Lila – ¡Sistema integral de gestión para asociaciones y dispensarios cannábicos! 🚀 Una solución completa y moderna para la administración.",
      fullDescription: "De asociaciones y dispensarios cannábicos que integra gestión de socios, productos, ventas, informes y control de acceso en una plataforma robusta y escalable.",
      features: [
        "👥 Panel Principal Inteligente: Dashboard interactivo con métricas en tiempo real",
        "👤 Gestión de Socios: Control completo de usuarios y membresías",
        "📦 Sistema de Productos: Catálogo completo de productos con gestión de stock",
        "🏪 Gestión de Dispensario: Control de productos dispensados",
        "💰 Sistema de Ventas: Procesamiento eficiente de transacciones"
      ],
      technologies: ["Angular 17", "Material Design", "Node.js", "Express", "PostgreSQL", "Docker"],
      image: "/images/projects/proyecto11.png",
      category: "web",
      status: "completed",
      links: {
        appStore: "https://apps.apple.com/es/app/gestionclub/id6753986407",
        demo: "https://r00tedbrain.github.io/GestionLilaAPP/"
      }
    },
    {
      id: 12,
      title: "DiscaMatch",
      subtitle: "",
      description: "💝 DiscaMatch – ¡Conectando corazones sin barreras! 🤝 Una plataforma inclusiva y segura diseñada específicamente para personas con diversidad funcional.",
      fullDescription: "Donde pueden encontrar amistad, amor y conexiones significativas en un entorno comprensivo y respetuoso.",
      features: [
        "🌈 Perfiles Inclusivos: Opciones personalizadas para describir tipos de diversidad funcional",
        "🤝 Match Inteligente: Algoritmo de compatibilidad basado en necesidades y preferencias similares",
        "💬 Comunicación Accesible: Chat con soporte para texto a voz y voz a texto",
        "🛡️ Seguridad y Privacidad: Verificación de perfiles para crear un entorno seguro",
        "♿ Accesibilidad Total: Diseño universal compatible con lectores de pantalla"
      ],
      technologies: ["Flutter", "Firebase", "Firebase Authentication", "Cloud Firestore", "Firebase Storage"],
      image: "/images/projects/proyecto12.png",
      category: "mobile",
      status: "completed",
      links: {
        demo: "https://r00tedbrain.github.io/adaptmatchwebsitev3/"
      }
    },
    {
      id: 13,
      title: "AlertaTelegram",
      subtitle: "Sistema de Emergencias Inteligente",
      description: "🚀 AlertaTelegram – Sistema de Emergencias Inteligente 🚨 Protección 24/7 con envío automático de ubicación, audio y fotos a tus contactos de confianza vía Telegram.",
      fullDescription: "Funciona en segundo plano para máxima seguridad.",
      features: [
        "🎤 Grabaciones de Audio: Envío automático cada 30 segundos en segundo plano",
        "📍 Ubicación en Tiempo Real: Actualización continua de posición GPS cada 10 segundos",
        "📷 Fotos de Emergencia: Captura automática de cámaras frontal y trasera cada 20 segundos",
        "📱 Mapa Interactivo: Visualización en tiempo real con pantalla completa",
        "🛡️ Funcionamiento en Background: Continúa funcionando aunque tu app esté cerrada"
      ],
      technologies: ["Flutter", "Telegram Bot API", "Geolocation", "Camera", "Background Services"],
      image: "/images/projects/alertateleg.png",
      category: "mobile",
      status: "completed",
      links: {
        appStore: "https://apps.apple.com/es/app/alertatelegram/id6745782674"
      }
    },
    {
      id: 14,
      title: "ShieldGuardAI",
      subtitle: "Generación Inteligente de Informes",
      description: "🚀 ShieldGuardAI – Generación Inteligente de Informes de Seguridad con IA 📋 Aplicación Angular especializada para ingenieros y arquitectos de España.",
      fullDescription: "Que automatiza la creación de informes de seguridad, planes de evacuación y documentación técnica profesional.",
      features: [
        "🤖 Inteligencia Artificial Avanzada: Procesamiento inteligente de datos empresariales en formato JSON",
        "📋 Planes de Evacuación: Creación automática de planes de evacuación profesionales",
        "🛡️ Planes de Seguridad: Elaboración de planes de seguridad integrales",
        "🚨 Planes de Respuesta a Incidencias: Protocolos de actuación ante emergencias",
        "🇪🇸 Especialización en Normativa Española: Cumplimiento con Real Decreto 393/2007"
      ],
      technologies: ["Angular", "Artificial Intelligence", "JSON Processing", "PDF Generation"],
      image: "/images/projects/shieldai.png",
      category: "web",
      status: "completed",
      links: {
        website: "https://shieldguardai.com/",
        demo: "https://r00tedbrain.github.io/ShieldGuardAi-DEMO/#/ShieldGuard"
      }
    },
    {
      id: 15,
      title: "Sherlock-OSINT",
      subtitle: "La App Definitiva de OSINT y Ciberseguridad",
      description: "🚀 Sherlock-OSINT – ¡La primera app móvil que reúne 16 herramientas profesionales de OSINT! Si eres pentester, investigador, profesional de ciberseguridad o simplemente quieres proteger tu privacidad digital, esta app es para ti.",
      fullDescription: "Primera aplicación móvil (iOS) y web que permite realizar investigaciones OSINT profesionales desde cualquier lugar. Con 16 herramientas integradas para analizar usuarios, emails, dominios, puertos, metadatos, bitcoin wallets y mucho más.",
      features: [
        "🔎 Username Analyzer: Busca perfiles en +400 plataformas sociales",
        "📧 Email Analyzer: Validación, reputación, análisis de seguridad",
        "📱 Phone Analyzer: Operador, país, tipo de línea",
        "🌐 Domain Analyzer: WHOIS, DNS, subdominios",
        "🔍 Port Scanner: Escaneo de puertos y servicios",
        "🔒 Shodan Search PRO: Dispositivos IoT y servidores",
        "🛡️ Reputation Checker: Verificación contra bases de amenazas",
        "💼 Company Intelligence: Geolocalización, tecnologías, contactos",
        "📋 BOE España: Búsqueda en Boletín Oficial del Estado",
        "📊 Metadata Extractor: EXIF, GPS, información de cámara",
        "🔐 Hash Analyzer: Identificación de tipos de hash",
        "📨 Email Forensics: Análisis de headers y routing",
        "₿ Bitcoin Analyzer: Análisis de wallets y transacciones",
        "🎯 Google Dorking: 50+ categorías automatizadas",
        "🗺️ Intelligence Map: Visualización estilo Maltego",
        "🔒 Privacidad extrema: Cero tracking, búsquedas anónimas"
      ],
      technologies: ["Flutter", "OSINT Framework", "Shodan API", "iOS", "Android", "Privacy First"],
      image: "/images/projects/sherlock-osint.png",
      category: "security",
      status: "completed",
      links: {
        appStore: "https://apps.apple.com/es/app/sherlock-osint/id6753150438",
        playStore: "https://play.google.com/store/apps/details?id=com.osint.osint_flutter"
      }
    },
    {
      id: 16,
      title: "TuAsistentedeFacturación",
      subtitle: "Gestión Inteligente para macOS",
      description: "🚀 TuAsistentedeFacturación – Gestión Inteligente de Facturación para macOS 💼 Asistente profesional desarrollado exclusivamente en Swift para Mac.",
      fullDescription: "Que simplifica la creación de facturas, presupuestos, gestión de gastos y administración de clientes.",
      features: [
        "📋 Creación de Facturas: Generación automática de facturas profesionales",
        "💰 Gestión de Presupuestos: Creación rápida de presupuestos detallados",
        "📊 Control de Gastos: Registro y categorización de gastos empresariales",
        "👥 Gestión de Clientes: Base de datos completa de clientes",
        "📈 Reportes y Análisis: Dashboard con métricas clave del negocio"
      ],
      technologies: ["Swift", "SwiftUI", "Core Data", "CloudKit", "PDFKit"],
      image: "/images/projects/asistente.png",
      category: "desktop",
      status: "completed",
      links: {
        appStore: "https://apps.apple.com/es/app/tuasistentedefacturación/id6743031327?mt=12"
      }
    },
    {
      id: 17,
      title: "CartasPicantes",
      subtitle: "Juego de Cartas para Parejas",
      description: "🔥 ¿Buscas una forma divertida y emocionante de conectar con tu pareja? CartasPicantes es el juego perfecto para parejas que quieren romper la rutina, descubrir nuevas facetas juntos y fortalecer su conexión. 💕",
      fullDescription: "Aplicación móvil desarrollada en Flutter y Firebase que ofrece un juego de cartas interactivo diseñado específicamente para parejas. Con más de 30 cartas diferentes, efectos de sonido y animaciones, CartasPicantes ayuda a las parejas a fortalecer su relación de manera divertida y emocionante.",
      features: [
        "🎮 Más de 30 cartas diferentes con retos y preguntas",
        "✨ Interfaz intuitiva y elegante",
        "🔊 Efectos de sonido y animaciones",
        "🔒 100% privado y seguro",
        "📴 Sin necesidad de conexión a internet para jugar",
        "💑 Diseñado para fortalecer la conexión de pareja",
        "🎯 Retos y preguntas para descubrir nuevas facetas",
        "🔥 Añade un toque picante a tus momentos especiales"
      ],
      technologies: ["Flutter", "Firebase", "Dart", "iOS", "Android"],
      image: "/images/projects/cartaspicantes.png",
      category: "mobile",
      status: "completed",
      links: {
        appStore: "https://apps.apple.com/es/app/cartaspicantes/id6752787153",
        playStore: "https://play.google.com/store/apps/details?id=com.marquez.parejas"
      }
    },
    {
      id: 18,
      title: "NarcoObservatorio",
      subtitle: "Noticias de Narcotráfico y Seguridad",
      description: "📰 NarcoObservatorio – Tu fuente confiable de información sobre narcotráfico, seguridad nacional y crimen organizado. Mantente informado con noticias actualizadas, análisis detallados y reportes especiales.",
      fullDescription: "Aplicación móvil desarrollada en Flutter que proporciona acceso a noticias actualizadas sobre narcotráfico, crimen organizado y seguridad pública. Con una interfaz intuitiva y categorización de contenido, NarcoObservatorio permite a usuarios interesados en seguridad y periodismo de investigación mantenerse al día con información verificada.",
      features: [
        "📱 Noticias en tiempo real sobre narcotráfico y seguridad",
        "🔍 Buscador avanzado de noticias",
        "📑 Categorización por temas: Narcotráfico, Operativos, Investigaciones",
        "🔔 Notificaciones push para noticias importantes",
        "💾 Guarda y comparte noticias de interés",
        "🌐 Navegador integrado con VPN privado",
        "📊 Estadísticas y análisis de tendencias",
        "🔒 Cumplimiento con RGPD y privacidad del usuario"
      ],
      technologies: ["Flutter", "Dart", "REST API", "Push Notifications", "iOS", "Android"],
      image: "/images/projects/narcoobservatorio.png",
      category: "mobile",
      status: "completed",
      links: {
        appStore: "https://apps.apple.com/es/app/narcoobservatorio/id6504436073",
        playStore: "https://play.google.com/store/apps/details?id=com.narcoobservatorio.news"
      }
    },
    {
      id: 19,
      title: "TrenInfo España",
      subtitle: "Horarios de Rodalies en Tiempo Real",
      description: "🚆 TrenInfo España – Tu compañero perfecto para moverte en tren por Cataluña. Horarios actualizados al segundo, alertas de incidencias y todas las líneas de Rodalies Barcelona en una sola app.",
      fullDescription: "Aplicación Flutter multiplataforma (iOS y Android) que ofrece información en tiempo real de la red de Rodalies Barcelona con datos oficiales de Renfe. Sin publicidad intrusiva, sin recopilación de datos personales y con soporte multiidioma (Español, Català, English).",
      features: [
        "🕐 Horarios en Tiempo Real: Actualizados al segundo con retrasos y cancelaciones",
        "🔍 Búsqueda Rápida: Encuentra tu estación en segundos por nombre o línea",
        "🚉 Todas las Líneas: R1, R2, R2N, R2S, R3, R4, R7, R8, R11, R12, R13, R14, R15, R16, R17",
        "🔔 Alertas e Incidencias: Notificaciones de retrasos y cortes de servicio en tiempo real",
        "🌐 Multiidioma: Español, Català e English con cambio instantáneo",
        "🔒 Privacidad Total: Sin registro, sin recopilación de datos personales",
        "📱 Compatible con iPhone, iPad y Android"
      ],
      technologies: ["Flutter", "Dart", "REST API", "Renfe Data", "iOS", "Android"],
      image: "/images/projects/treninfo.png",
      category: "mobile",
      status: "completed",
      links: {
        appStore: "https://apps.apple.com/es/app/treninfo-españa/id6754086220",
        playStore: "https://play.google.com/store/apps/details?id=com.marquez.renfe24h"
      }
    },
    {
      id: 20,
      title: "RentP2P",
      subtitle: "Alquiler de Vehículos entre Particulares",
      description: "🚗 RentP2P – La plataforma de movilidad compartida más completa de España. Conecta a propietarios y arrendatarios con verificación KYC, contratos digitales y pagos seguros.",
      fullDescription: "Aplicación Flutter completa con autenticación social (Google Sign-In, Apple Sign-In) y verificación KYC obligatoria. Mapa interactivo, contratos digitales con firma electrónica y sistema de valoraciones bidireccional para crear una comunidad de confianza.",
      features: [
        "🆔 Verificación KYC: Identidad obligatoria para todos los usuarios",
        "🗺️ Mapa Interactivo: Encuentra vehículos cerca de ti en tiempo real",
        "📝 Contratos Digitales: Firma electrónica con validez legal",
        "⭐ Sistema de Valoraciones: Reputación bidireccional propietario/arrendatario",
        "💳 Pagos Seguros: Procesamiento integrado a través de la plataforma",
        "🚙 Múltiples Vehículos: Coches, furgonetas, motos, bicicletas, patinetes, caravanas",
        "🇪🇸 Cobertura Nacional: Disponible en toda España",
        "🛡️ Soporte Dedicado: Atención al cliente y políticas claras de cancelación"
      ],
      technologies: ["Flutter", "Dart", "Google Sign-In", "Apple Sign-In", "KYC", "Stripe", "Maps SDK"],
      image: "/images/projects/rentp2p.png",
      category: "mobile",
      status: "completed",
      links: {
        appStore: "https://apps.apple.com/es/app/rentp2p/id6758356874",
        playStore: "https://play.google.com/store/apps/details?id=com.rentp2p.rentp2p"
      }
    },
    {
      id: 21,
      title: "Mollet Avisa",
      subtitle: "Red Social Vecinal de Mollet del Vallès",
      description: "🏘️ Mollet Avisa – ¡Conecta con tus vecinos de Mollet del Vallès! Avisos de barrio, ofertas de empleo, agenda de eventos y servicios entre vecinos en una sola app. Proyecto independiente, no oficial.",
      fullDescription: "Aplicación Flutter pensada para crear comunidad local en Mollet del Vallès. Permite a los vecinos compartir avisos, descubrir eventos del barrio, encontrar trabajo y servicios profesionales recomendados, y mantenerse informados de lo que ocurre en su zona.",
      features: [
        "📣 Avisos Vecinales: Publica situaciones de tu barrio con fotos y ubicación",
        "🎉 Agenda de Eventos: Mercadillos, fiestas del barrio y actividades de la comunidad",
        "💼 Tablón de Empleo: Ofertas de trabajo de vecinos y comercios locales",
        "🔧 Servicios entre Vecinos: Fontaneros, electricistas y profesionales recomendados",
        "🗺️ Mapa Interactivo: Visualiza avisos y eventos de tu zona",
        "🔔 Notificaciones por Barrio: Solo lo que pasa cerca de ti",
        "🆓 Totalmente Gratuita: Contenido 100% generado por la comunidad"
      ],
      technologies: ["Flutter", "Dart", "Firebase", "Cloud Firestore", "Maps", "Push Notifications"],
      image: "/images/projects/molletavisa.png",
      category: "mobile",
      status: "completed",
      links: {
        appStore: "https://apps.apple.com/es/app/mollet-avisa/id6758706956",
        playStore: "https://play.google.com/store/apps/details?id=com.molletvalles.mollet_avisa"
      }
    },
    {
      id: 22,
      title: "Serviclick",
      subtitle: "Marketplace de Servicios Profesionales",
      description: "🛠️ Serviclick – Conecta a personas que necesitan servicios con profesionales verificados. Más de 20 categorías de servicios, registro OTP, KYC y sistema de comisiones por leads.",
      fullDescription: "Plataforma web + apps móviles (React + Expo) que funciona como marketplace de servicios. Sistema completo de venta de leads a profesionales, verificación de identidad KYC, registro con OTP y panel de gestión de comisiones. Diseñada para escalar con miles de profesionales y clientes.",
      features: [
        "📋 +20 Categorías de Servicios: Reformas, limpieza, mudanzas, técnicos, consultoría y más",
        "🆔 Registro con OTP + KYC: Verificación robusta de profesionales",
        "💼 Sistema de Leads: Compra/venta de oportunidades comerciales con comisiones",
        "🌐 Web + iOS + Android: Una sola base de código (Expo + React)",
        "💳 Pagos Integrados: Procesamiento seguro de transacciones y comisiones",
        "⭐ Valoraciones y Reputación: Sistema bidireccional cliente/profesional",
        "📊 Panel de Profesional: Gestión de leads, presupuestos y facturación",
        "🔔 Notificaciones Push: Nuevos leads y oportunidades en tiempo real"
      ],
      technologies: ["React", "Expo", "TypeScript", "Node.js", "PostgreSQL", "Stripe", "OTP", "KYC"],
      image: "/images/projects/serviclick.png",
      category: "web",
      status: "completed",
      links: {
        website: "https://serviclick.es/"
      }
    },
    {
      id: 23,
      title: "SpyGuard",
      subtitle: "Contravigilancia y Anti-Espionaje",
      description: "🛡️ SpyGuard – La app más honesta de contravigilancia para Android e iOS. 9 módulos de detección con tecnología REAL para encontrar cámaras ocultas, micrófonos, trackers BLE y torres celulares maliciosas. Cero alarmismo, todo evidencia.",
      fullDescription: "Aplicación nativa pura: Kotlin para Android y Swift para iOS. Funcionamiento 100% offline, sin cuentas, sin telemetría. Cada detección está respaldada por evidencia real: paquetes de red, datos de sensores, espectros FFT y muestras de radio. Limitaciones documentadas dentro de la propia app.",
      features: [
        "📡 Recon Red: Barrido ARP + escaneo de 14 puertos de cámara + fingerprinting de 17 fabricantes (Hikvision, Dahua, Axis, Reolink, TP-Link Tapo, Ring, Arlo, etc.)",
        "🧲 Barrido EMF: Magnetómetro en tiempo real para detectar motores, bobinas y altavoces ocultos",
        "🔴 Detección IR: Localiza LEDs infrarrojos 850nm de cámaras de visión nocturna con la cámara del móvil",
        "📍 Intercepción BLE: Detecta AirTag (0x004C), Tile (0x00E0), Samsung SmartTag (0x0075) y Chipolo (0x049A) con medición RSSI",
        "🎙️ Barrido Audio: FFT real a 48 kHz + monitor ultrasonido 18-22 kHz para micrófonos encubiertos",
        "📶 Recon WiFi: Detector de rogue AP / gemelo malicioso + patrones SSID de cámaras",
        "💡 Caza de Reflejos: Linterna + detección de retrorreflexiones de lentes ocultas",
        "📡 Recon Células: Detector pasivo heurístico de IMSI catchers tipo Stingray (8 comprobaciones)",
        "🎯 Modo Barrido: Ejecuta los 8 módulos en 12 fases, genera puntuación 0-100 y reporte forense JSON/HTML",
        "🔒 100% Offline: Sin cuentas, sin telemetría, sin tracking, sin venta de datos"
      ],
      technologies: ["Kotlin", "Swift", "Native Android", "Native iOS", "FFT", "BLE Scanning", "Network Forensics"],
      image: "/images/projects/spyguard.png",
      category: "security",
      status: "completed",
      links: {
        playStore: "https://play.google.com/store/apps/details?id=com.sofia.spyguard"
      }
    },
    {
      id: 24,
      title: "Pernocta",
      subtitle: "+40.000 Lugares para Dormir y +50.000 WiFis Gratuitos",
      description: "🚐 Pernocta – La app definitiva para viajeros y autocaravanas. Más de 40.000 lugares donde dormir con reseñas de la comunidad y más de 50.000 puntos de conexión WiFi gratuitos en toda Europa.",
      fullDescription: "Aplicación Flutter pensada para nómadas, viajeros en autocaravana, vanlife y mochileros. Base de datos masiva con áreas de pernocta, parkings, campings, gasolineras 24h y WiFis gratuitos verificados por la comunidad.",
      features: [
        "🏕️ +40.000 Lugares de Pernocta: Áreas, parkings, campings y zonas permitidas",
        "📶 +50.000 WiFis Gratuitos: Geolocalizados con velocidad y fiabilidad reportada",
        "⭐ Reseñas de la Comunidad: Valoraciones reales de viajeros como tú",
        "🗺️ Mapa Offline: Funcionalidad sin conexión para viajes remotos",
        "🚿 Filtros por Servicios: Agua, electricidad, vaciado, ducha, baños",
        "📷 Fotos de Usuarios: Mira el lugar antes de llegar",
        "🚐 Pensado para Autocaravanas: Restricciones de altura, peso y tamaño",
        "🆓 Gratuita y sin Anuncios Intrusivos"
      ],
      technologies: ["Flutter", "Dart", "Maps", "Offline-First", "Cloud Firestore", "Geolocation"],
      image: "/images/projects/pernocta.png",
      category: "mobile",
      status: "completed",
      links: {
        appStore: "https://apps.apple.com/es/app/pernocta/id6760240923"
      }
    },
    {
      id: 25,
      title: "Legends of Strike",
      subtitle: "RPG Medieval Multijugador en Roblox",
      description: "🏰 Legends of Strike – Adéntrate en un peligroso mundo medieval lleno de aventura. Elige tu clase (Berserker, Mago, Nigromante o Explorador) y defiende el reino de hordas infinitas de monstruos.",
      fullDescription: "Juego RPG de acción multijugador multiplataforma desarrollado en Roblox. Combate épico por clases, sistema de progresión, gestión de maná e invocaciones únicas, con hub de castillo y batallas cooperativas para jugar con amigos.",
      features: [
        "⚔️ Combate Épico: Lucha contra zombies, orcos, momias, criaturas de sombra y jefes con habilidades de clase únicas",
        "🐺 Invocaciones y Habilidades: Nigromantes invocan no-muertos, Exploradores llaman lobos, Magos lanzan fuego, Berserkers arrasan cuerpo a cuerpo",
        "📈 Progresión RPG: Sube de nivel, gana XP y mejora Fuerza, Sabiduría e Inteligencia",
        "🔮 Sistema de Maná: Gestiona tu maná para lanzar habilidades; la Inteligencia aumenta regeneración y capacidad",
        "🏰 Hub del Castillo: Comienza a salvo en el castillo antes de aventurarte en las zonas de batalla",
        "👥 Aventura Multijugador: Forma equipo con amigos para superar las hordas"
      ],
      technologies: ["Roblox", "Luau", "Game Design", "Multiplayer", "Cross-Platform"],
      image: "/images/projects/legends-of-strike.jpeg",
      category: "mobile",
      status: "completed",
      links: {
        roblox: "https://www.roblox.com/es/games/105101693577723/Legends-of-Strike",
        discord: "https://discord.gg/GttvzNP3ra"
      }
    },
    {
      id: 26,
      title: "CatchPets GO",
      subtitle: "Caza de Mascotas Reales con IA y AR",
      description: "🐾 CatchPets GO – El perro de tu vecino puede ser LEGENDARIO. Apunta con la cámara a una mascota REAL, la IA la detecta y creas una carta coleccionable con su foto, rareza, tribu y stats. Convierte tu barrio en un mundo 3D vivo.",
      fullDescription: "Juego multijugador en vivo con detección de mascotas reales mediante IA y realidad aumentada. Aquí no hay bichos inventados por un servidor: las cartas se generan a partir de perros, gatos y aves de verdad. Disponible en beta para Android e iOS.",
      features: [
        "📸 Detección con IA: Apunta a una mascota real y la IA la reconoce para crear su carta",
        "🃏 Cartas de Mascotas Reales: Cada carta usa la foto real del animal, con rareza, tribu y stats",
        "🗺️ Barrio en 3D: Tu zona real convertida en un mundo tridimensional vivo",
        "💬 Equipos con Chat en Vivo: Coordina la caza con tu equipo en tiempo real",
        "⚔️ Batallas PvP 3v3: Combates en directo con súper ataques",
        "🏕️ Campamento: Entrena a tus mascotas y farmea aura",
        "⭐ 8 Rangos de Aura: De Chispa a Leyenda; solo el 1% de los animales son legendarios",
        "🏆 Descubridor: Si encuentras un legendario primero, tu nombre queda grabado para siempre"
      ],
      technologies: ["AI", "Computer Vision", "AR", "Real-time Multiplayer", "iOS", "Android"],
      image: "/images/projects/catchpetsgo.png",
      category: "ai",
      status: "completed",
      links: {
        website: "https://catchpetsgo.app",
        playStore: "https://play.google.com/store/apps/details?id=com.catchpetsgo.app",
        testflight: "https://testflight.apple.com/join/J42gMyq6",
        discord: "https://discord.gg/WYUMt9HKp",
        telegram: "https://t.me/CatchPetsGoBot"
      }
    },
    {
      id: 27,
      title: "TeHeDesing",
      subtitle: "Asesora con IA y CRM para Boutiques",
      description: "👰 TeHeDesing – Dos herramientas en una: una asesora virtual con IA que analiza a tu clienta y le muestra cómo le queda el vestido puesto, y el CRM completo de tu boutique. Para tiendas de novia, fiesta, sastrería y comunión.",
      fullDescription: "Plataforma SaaS con backend NestJS que combina inteligencia artificial (análisis de silueta, colorimetría y prueba virtual del vestido) con la gestión integral de la boutique: agenda, ventas, inventario, red de stock entre tiendas y equipo. Menos tiempo probando con la libreta, más tiempo vendiendo.",
      features: [
        "🤖 Asesora con IA: analiza la silueta (7 tipos clásicos) y la colorimetría (12 estaciones de color) y recomienda con criterio",
        "👗 Prueba Virtual del Vestido: la clienta se ve tu catálogo puesto sin desvestirse, ordenado por afinidad",
        "📅 Agenda y Reservas Online: calendario con recordatorios automáticos y reserva pública con señal (Bizum)",
        "💳 Ventas y Encargos (POS): tickets con IVA, pagos a cuenta, arreglos y firma de la clienta en pantalla",
        "📦 Inventario con Margen: coste, PVP y margen por prenda, etiquetas con código de barras y escáner con cámara",
        "🏬 Red de Stock: disponibilidad de tallas entre todas tus boutiques en tiempo real",
        "👥 Equipo y Roles: acceso con Google por rol (propietaria, gerente, vendedora)"
      ],
      technologies: ["NestJS", "TypeScript", "PostgreSQL", "AI", "Computer Vision", "React"],
      image: "/images/projects/tehedesing.png",
      category: "web",
      status: "completed",
      links: {
        website: "https://tehedesing.app/"
      }
    },
    {
      id: 28,
      title: "SmartGAIA",
      subtitle: "Gestión Operativa para Hoteles",
      description: "🏨 SmartGAIA – La app de gestión operativa para hoteles. Reúne en una sola app todo lo que tu equipo necesita para el día a día, accesible desde el móvil y adaptado al rol de cada persona, con asistente Gaia integrado.",
      fullDescription: "Aplicación multiplataforma (React + Expo) que centraliza la operativa del hotel, mejora la coordinación entre departamentos y da a dirección y jefaturas el control de lo que ocurre en tiempo real. Incluye el asistente Gaia para consultar y operar por comandos.",
      features: [
        "✅ Operativa Diaria: tareas y checklists por turno, incidencias y averías, estado de pisos, reservas y servicios, pedidos y eventos",
        "🔧 Mantenimiento: calendario preventivo, inventario de activos con ficha técnica, historial de averías y panel analítico de costes",
        "👥 Equipo y Jornada: cuadrante semanal, fichajes, peticiones (vacaciones, festivos) y área personal (nóminas, contratos)",
        "💰 Gastos y Documentación: gastos, albaranes, facturas, inventarios y base de conocimiento por áreas",
        "💬 Comunicación Interna: buzón del hotel, formación y seguimiento del equipo",
        "🤖 Asistente Gaia: consulta y opera el hotel por comandos con IA",
        "🔐 Acceso según el Rol: dirección, jefaturas y personal ven solo lo que les corresponde"
      ],
      technologies: ["React", "Expo", "TypeScript", "React Native", "AI Assistant"],
      image: "/images/projects/smart-gaia-nativa.png",
      category: "mobile",
      status: "completed",
      links: {
        playStore: "https://play.google.com/store/apps/details?id=com.r00tedbrain.gaianative"
      }
    }
  ];

  const categories = [
    { key: 'all', label: 'Todos' },
    { key: 'security', label: 'Seguridad' },
    { key: 'mobile', label: 'Móvil' },
    { key: 'web', label: 'Web' },
    { key: 'ai', label: 'IA/ML' },
    { key: 'desktop', label: 'Desktop' }
  ];

  const filteredProjects = activeCategory === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeCategory);

  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 }
  };

  const staggerContainer = {
    initial: {},
    whileInView: {
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  // ──────────────────────────────────────────────────────────────────────────
  // SEO: schema.org SoftwareApplication para cada proyecto con stores.
  // Google procesa JSON-LD inyectado por JS y puede generar Rich Results
  // (caja de instalación de app) en búsquedas relacionadas.
  // ──────────────────────────────────────────────────────────────────────────
  const categoryToAppCategory: Record<Project['category'], string> = {
    mobile: 'UtilitiesApplication',
    security: 'SecurityApplication',
    web: 'BusinessApplication',
    ai: 'BusinessApplication',
    desktop: 'BusinessApplication',
  };

  const appProjects = projects.filter(
    (p) => p.links && (p.links.playStore || p.links.appStore)
  );

  const softwareApplicationLdJson = {
    '@context': 'https://schema.org',
    '@graph': appProjects.map((p) => {
      const operatingSystems: string[] = [];
      if (p.links?.playStore) operatingSystems.push('ANDROID');
      if (p.links?.appStore) operatingSystems.push('iOS');

      const sameAs: string[] = [];
      if (p.links?.playStore) sameAs.push(p.links.playStore);
      if (p.links?.appStore) sameAs.push(p.links.appStore);
      if (p.links?.website) sameAs.push(p.links.website);
      if (p.links?.fdroid) sameAs.push(p.links.fdroid);

      return {
        '@type': 'SoftwareApplication',
        name: p.title,
        description: p.description.replace(/[🚀🔒🛡️📱💼🚗🏘️🛠️📡🧲🔴📍🎙️📶💡🎯🆔🗺️📝⭐💳🚙🇪🇸🚐🏕️🚿📷🆓🔐🐾🏪🍽️🏥🏠⚖️🎓🏭]/gu, '').trim(),
        applicationCategory: categoryToAppCategory[p.category],
        operatingSystem: operatingSystems.length ? operatingSystems.join(', ') : 'Web',
        image: `https://immoactivatiassociatssl.com${p.image}`,
        url: 'https://immoactivatiassociatssl.com/#projects',
        sameAs,
        author: {
          '@type': 'Organization',
          name: 'IMMOACTIVAT I ASSOCIATS SL',
          url: 'https://immoactivatiassociatssl.com/',
        },
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'EUR',
        },
      };
    }),
  };

  return (
    <section id="projects" className="projects section">
      {/* JSON-LD SoftwareApplication para Rich Results de apps */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareApplicationLdJson) }}
      />

      <div className="container">
        <motion.div
          variants={staggerContainer}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true }}
        >
          <motion.h2 
            className="section-title neon-text animate-glow"
            variants={fadeInUp}
          >
            Proyectos Destacados
          </motion.h2>

          <motion.p 
            className="projects-subtitle"
            variants={fadeInUp}
          >
            Soluciones innovadoras que demuestran nuestra experiencia en desarrollo seguro, 
            tecnologías avanzadas y diseño centrado en el usuario.
          </motion.p>

          <motion.div 
            className="category-filters"
            variants={fadeInUp}
          >
            {categories.map((category) => (
              <button
                key={category.key}
                className={`filter-btn ${activeCategory === category.key ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.key)}
              >
                {category.label}
              </button>
            ))}
          </motion.div>

          <motion.div 
            className="projects-grid"
            variants={staggerContainer}
          >
            {filteredProjects.map((project, index) => (
              <motion.div
                key={project.id}
                className="project-card glass-card"
                variants={fadeInUp}
                whileHover={{ y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <div className="project-image">
                  <img
                    src={project.image}
                    alt={`${project.title} — ${project.subtitle || project.description.slice(0, 80)}`}
                    loading={index < 3 ? 'eager' : 'lazy'}
                    decoding="async"
                    width="600"
                    height="400"
                  />
                  <div className="project-overlay">
                    <span className={`project-status ${project.status}`}>
                      {project.status === 'completed' ? '✓ Completado' : '⚡ En Desarrollo'}
                    </span>
                  </div>
                </div>

                <div className="project-content">
                  <div className="project-header">
                    <h3 className="project-title">{project.title}</h3>
                    <p className="project-subtitle">{project.subtitle}</p>
                  </div>

                  <p className="project-description">{project.description}</p>

                  <div className="project-features">
                    <h4>Características Principales:</h4>
                    <ul>
                      {project.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="project-technologies">
                    <h4>Tecnologías:</h4>
                    <div className="tech-tags">
                      {project.technologies.map((tech, idx) => (
                        <span key={idx} className="tech-tag">{tech}</span>
                      ))}
                    </div>
                  </div>

                  {project.links && (
                    <div className="project-links">
                      <h4>Enlaces:</h4>
                      <div className="project-buttons">
                        {project.links.playStore && (
                          <a 
                            href={project.links.playStore} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="project-link play-store"
                          >
                            📱 Play Store
                          </a>
                        )}
                        {project.links.appStore && (
                          <a 
                            href={project.links.appStore} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="project-link app-store"
                          >
                            🍎 App Store
                          </a>
                        )}
                        {project.links.fdroid && (
                          <a 
                            href={project.links.fdroid} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="project-link fdroid"
                          >
                            🤖 F-Droid
                          </a>
                        )}
                        {project.links.demo && (
                          <a 
                            href={project.links.demo} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="project-link demo"
                          >
                            🚀 Ver Demo
                          </a>
                        )}
                        {project.links.website && (
                          <a 
                            href={project.links.website} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="project-link website"
                          >
                            🌐 Sitio Web
                          </a>
                        )}
                        {project.links.roblox && (
                          <a
                            href={project.links.roblox}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="project-link roblox"
                          >
                            🎮 Jugar en Roblox
                          </a>
                        )}
                        {project.links.testflight && (
                          <a
                            href={project.links.testflight}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="project-link app-store"
                          >
                            🍎 TestFlight (iOS)
                          </a>
                        )}
                        {project.links.discord && (
                          <a
                            href={project.links.discord}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="project-link discord"
                          >
                            💬 Discord
                          </a>
                        )}
                        {project.links.telegram && (
                          <a
                            href={project.links.telegram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="project-link telegram"
                          >
                            ✈️ Telegram
                          </a>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </motion.div>

          <motion.div 
            className="projects-cta"
            variants={fadeInUp}
          >
            <h3 className="gradient-text">¿Tienes una idea innovadora?</h3>
            <p>Conversemos sobre cómo podemos convertir tu visión en una solución digital segura y escalable.</p>
            <button 
              className="btn-primary"
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Iniciar Proyecto
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
